import { Box, Grid, MenuItem, Select, TextField, Stack, Button, IconButton, Tooltip, InputAdornment } from '@mui/material';
import React, { useState, useEffect } from 'react'
import { DatePickerStyle, ErrorTypography, SecondaryTypography, StyledTypography } from '../../Theme';
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import { NameRegex, No_special_regex } from '../../Utils';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axiosInstance from '../../Redux/AxiosInstance';
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function AddOrganization() {

    const navigate = useNavigate()
    const { userDetails } = useSelector((state) => state.Login);
    //(userDetails)
    const initialDeviceData = {
        name: "",
        email: "",
        phone: "",
        address: "",
        company_name : "",
        level : "",
        unit : "",
        accessstartdate: null,
        accessenddate: null,
    }
    const [PersonalDetailsData, setPersonalDetailsData] = useState({
        ...initialDeviceData
      });

      const {id} = useParams();
      const location = useLocation();
      const {deviceData} = location.state || {};

      useEffect(() => {
        if(!id){
            setPersonalDetailsData({
                ...initialDeviceData,
                accessstartdate: dayjs(),
            })
        }
      }, []);

      useEffect(() => {
        if(id && deviceData){
            setPersonalDetailsData({
                name: deviceData.name || "",
                company_name : deviceData.company_name || "",
                level : deviceData.level || "",
                unit : deviceData.unit || "",
                email: deviceData.email || "",
                phone: deviceData.phone || "",
                address: deviceData.address || "",
                accessstartdate: deviceData.on_board_date || null,
                accessenddate: deviceData.off_board_date || null,
            });
        }
      }, [id, deviceData]);

      //(PersonalDetailsData)


      const [loading, setLoading] = useState(false)
      const [listBuilding, setListBuilding] = useState([])
      const [deviceList, setDeviceList] = useState([])
      const [enableEmail, setEnableEmail] = useState(false)

      // const deviceList = [
      //     {
      //         id : 1,
      //         name : 'Facial Recognition (FR) & Quick Response (QR)',
      //     },
      //     {
      //         id : 3,
      //         name : 'Automatic Number Plate Recognition (ANPR)',
      //     }
      // ]

      const [errtext, seterrtext] = useState({
        PersonalDetailsData: {...initialDeviceData},
      });

      //(errtext, 'err')
      const getAllVisitors = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}all_list_building`)
          //(response)
          if(response.status === 200){
            setListBuilding(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          //(error, 'list devices')
          setLoading(false);
      }
  }

      const getDeviceTypes = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}list_camera_type`)
          //(response)
          if(response.status === 200){
            setDeviceList(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          //(error, 'list devices')
          setLoading(false);
      }
  }
  
    // useEffect(() => {
    //   getAllVisitors();
    //   getDeviceTypes()
    // }, []);


     const handlePersonalDetails = (e, name) => {
  let fieldName;
  let fieldValue;

  // Case 1: Controlled components (DatePicker, Phone input, etc.)
  if (name) {
    fieldName = name;

    // Date fields
    if (["accessstartdate", "accessenddate"].includes(name)) {
      fieldValue = e
        ? moment(e.toDate ? e.toDate() : e).format("YYYY-MM-DD")
        : "";
    }
    // Phone field
    else if (name === "phone") {
      fieldValue = e ? `+${e}` : "";
    }
    // Other controlled fields
    else {
      fieldValue = e;
    }
  }
  // Case 2: Normal input fields
  else {
    fieldName = e.target.name;
    fieldValue = e.target.value;
  }

  // Update data
  setPersonalDetailsData((prev) => ({
    ...prev,
    [fieldName]: fieldValue,
  }));

  // Update error
  seterrtext((prev) => ({
    ...prev,
    PersonalDetailsData: {
      ...prev.PersonalDetailsData,
      [fieldName]: fieldValue ? "" : "This field is required",
    },
  }));
};


const validatePersonalDetails = () => {
  const newErrors = {};

  if (!PersonalDetailsData.name.trim()) {
    newErrors.name = "Host Name is required";
  } else if (PersonalDetailsData.name.length > 70) {
  newErrors.name = "Host Name must be 70 characters or less";
}
  if (!PersonalDetailsData.company_name.trim()) {
    newErrors.company_name = "Organization Name is required";
  } else if (PersonalDetailsData.company_name.length > 70) {
  newErrors.company_name = "Organization Name must be 70 characters or less";
}

  if (!PersonalDetailsData.address.trim()) {
    newErrors.address = "Address is required";
  } else if (PersonalDetailsData.address.length > 200) {
    newErrors.address = "Address must be 200 characters or less";
  }

  if (!PersonalDetailsData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(PersonalDetailsData.email)) {
    newErrors.email = "Enter a valid email";
  }

  if (!PersonalDetailsData.phone.trim()) {
  newErrors.phone = "Phone number is required";
} 
  if (!PersonalDetailsData.accessstartdate) {
  newErrors.accessstartdate = "Onboard Date is required";
} 

if (PersonalDetailsData.accessenddate) {
    const onboardDate = dayjs(PersonalDetailsData.accessstartdate);
    const offboardDate = dayjs(PersonalDetailsData.accessenddate);
    
    if (offboardDate.isBefore(onboardDate)) {
      newErrors.accessenddate = "Offboard Date must be after Onboard Date";
    }
  }
//   if (!PersonalDetailsData.accessenddate) {
//   newErrors.accessenddate = "Access End Date is required";
// } 

// else if (!/^\+65\d{8}$/.test(PersonalDetailsData.phone)) {
//   newErrors.phone = "Enter a valid Singapore number (e.g. +65XXXXXXXX)";
// }

  // Update the error state
  seterrtext((prev) => ({
    ...prev,
    PersonalDetailsData: {
      ...prev.PersonalDetailsData,
      ...newErrors,
    },
  }));

  // If no errors, return true
  return Object.keys(newErrors).length === 0;
};

      const saveDevice = async () => {
         if (validatePersonalDetails()) {
         
          setLoading(true)
          if(id){
             try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}company_update/${id}?updater_email=${userDetails?.email}`, {
                  // ...PersonalDetailsData,
                  name: PersonalDetailsData.name,
        email: PersonalDetailsData.email,
        phone: PersonalDetailsData.phone.length > 3 ? PersonalDetailsData.phone : "",
        address: PersonalDetailsData.address,
        company_name : PersonalDetailsData.company_name,
        level : PersonalDetailsData.level,
        unit : PersonalDetailsData.unit,
        on_board_date : dayjs(PersonalDetailsData.accessstartdate).format("YYYY-MM-DD"),
        off_board_date : PersonalDetailsData.accessenddate,
                  created_by : userDetails.id,
                  role_id : 5,
                  create_role : userDetails.user_role
              })
              //(response)
              if(response?.data?.status === 200){
                  //('created')
                  toast.success("Organization Updated Successfully")
                  setTimeout(() => {
                      navigate('/create_organization')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              //(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          } else {
             try {
              const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}company_create?creator_email=${userDetails?.email}`, {
                  // ...PersonalDetailsData,
                  name: PersonalDetailsData.name,
        email: PersonalDetailsData.email,
        phone: PersonalDetailsData.phone.length > 3 ? PersonalDetailsData.phone : "",
        address: PersonalDetailsData.address,
        company_name : PersonalDetailsData.company_name,
        level : PersonalDetailsData.level,
        unit : PersonalDetailsData.unit,
        on_board_date : dayjs(PersonalDetailsData.accessstartdate).format("YYYY-MM-DD"),
        off_board_date : PersonalDetailsData.accessenddate,        
                  created_by : userDetails.id,
                  role_id : 5,
                  create_role : userDetails.user_role
              })
              //(response)
              if(response?.data?.status === 201){
                  //('created')
                  toast.success("Organization Created Successfully")
                  setTimeout(() => {
                      navigate('/create_organization')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              //(error.response, 'saveDevice')
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          }
         }
      }


  return (
      <>
      <ToastContainer
                  autoClose='3000'
                  position="bottom-center"
                  toastClassName="custom-toast"
                  hideProgressBar={true}
                />
    <Box
          mt={3}
          component="div"
        //   boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Organization Details</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px  ",
            }}
          >
            <Grid xs={12} sm={5.8}>
              <StyledTypography>Organization Name</StyledTypography>
              <TextField
                name="company_name"
                value={PersonalDetailsData.company_name}
                onChange={handlePersonalDetails}
                disabled={id ? true : false}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 50 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.company_name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.company_name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.company_name}
              </ErrorTypography>
            </Grid>
            <Grid xs={12} sm={5.8}>
              <StyledTypography>Host Name</StyledTypography>
              <TextField
                name="name"
                value={PersonalDetailsData.name}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }} 
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.name}
              </ErrorTypography>
            </Grid>

             <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Level</StyledTypography>
              <TextField
                name="level"
                value={PersonalDetailsData.level}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.level
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.level
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.level}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Unit</StyledTypography>
              <TextField
                name="unit"
                value={PersonalDetailsData.unit}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.unit
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.unit
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.unit}
              </ErrorTypography>
            </Grid>


            <Grid xs={12} sm={5.8} mt={2}>
            <Box sx={{display : 'flex', justifyContent : 'space-between', alignItems : 'center', gap : 1}}>
              <StyledTypography>Email</StyledTypography>
              {/* {id && (
                  <IconButton onClick={() => setEnableEmail(!enableEmail)}><EditIcon /></IconButton>
              )}
               */}
              {id && (
              <Tooltip title="Once the email is updated, please click on Update to apply and make the changes effective.">
                  <InfoOutlinedIcon
                    sx={{
                     
                      fontSize: 18,
                      color: "#6B7280",
                      cursor: "pointer",
                      "&:hover": {
                        color: "#800000",
                      },
                    }}
                  />
                </Tooltip>
                )}
              
              </Box>
              <TextField
                name="email"
                value={PersonalDetailsData.email}
                onChange={handlePersonalDetails}
                disabled={id && !enableEmail}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 70 }}
                InputProps={{ disableUnderline: true, endAdornment: id && (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setEnableEmail(!enableEmail)}
          edge="end"
        >
          <EditIcon />
        </IconButton>
      </InputAdornment>
    ), }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.email
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.email
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.email}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Phone</StyledTypography>
              {/* <TextField
                name="phone"
                value={PersonalDetailsData.phone}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.phone
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.phone
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
              /> */}
              <Box sx={{mt: 1}}>
               <PhoneInput
                                    value={PersonalDetailsData.phone}
                                    // onChange={(value, country, e) =>
                                    //   handleMobileInput(
                                    //     value,
                                    //     country,
                                    //     setPersonalDetailsData,
                                    //     PersonalDetailsData,
                                    //     "PersonalDetailsData"
                                    //   )
                                    // }
                                    
                                    onChange={(e) => handlePersonalDetails(e, "phone")}
                                    inputProps={{  maxLength: 20 }}
                                    country={"sg"}
                                    buttonStyle={{ border: "none" }}
                                    inputStyle={{
                                      backgroundColor: errtext.PersonalDetailsData.phone
                                        ? "#FEE4E2"
                                        : " #F9FAFB",
                                      border: "none",
                                      height: "46px",
                                      width: "100%",
                                      marginTop : "8px",
                                      borderRadius: "8px",
                                      color: errtext.PersonalDetailsData.phone
                                        ? "#912018"
                                        : "#111927",
                                    }}
                                    countryCodeEditable={false}
                                    placeholder=""
                                    specialLabel="" 
                                  />
                                  </Box>
              <ErrorTypography>
                {errtext.PersonalDetailsData.phone}
              </ErrorTypography>
            </Grid>

            

           

            <Grid xs={12} sm={12} mt={2}>
              <StyledTypography>
                Address
              </StyledTypography>
              <TextField
                name="address"
                value={PersonalDetailsData.address}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !No_special_regex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 100 }}
                multiline
                rows={3}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.address}
              </ErrorTypography>
            </Grid>


            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Onboard Date</StyledTypography>
              <DatePicker
    //           open={openDatePicker}
    // onOpen={() => setOpenDatePicker(true)}
    // onClose={() => setOpenDatePicker(false)}
                format="DD/MM/YYYY"
                slots={{
                  openPickerIcon: () => <DatePickerIcon />,
                }}
                name="accessstartdate"
                defaultValue={dayjs()}
                value={
    PersonalDetailsData.accessstartdate
      ? dayjs(PersonalDetailsData.accessstartdate)
      : null
  }
  minDate={dayjs()}
  maxDate={dayjs().add(3, 'month')}
                onChange={(newValue) => handlePersonalDetails(newValue, "accessstartdate")}
                sx={{
                  ...DatePickerStyle,
                  backgroundColor: Boolean(
                    errtext.PersonalDetailsData.accessstartdate
                  )
                    ? "#FEE4E2"
                    : "",

                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.accessstartdate
                      ? "#912018"
                      : "#111927",
                  },
                }}
                 slotProps={{
      textField: {
        // onMouseEnter: () => setOpenDatePicker(true),
        // onMouseLeave: () => setOpenDatePicker(false),
      },
    }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.accessstartdate}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
  <StyledTypography>Offboard Date</StyledTypography>
  <DatePicker
    format="DD/MM/YYYY"
    slots={{
      openPickerIcon: () => <DatePickerIcon />,
    }}
    name="accessenddate"
    value={
      PersonalDetailsData.accessenddate
        ? dayjs(PersonalDetailsData.accessenddate)
        : null
    }
    minDate={
      PersonalDetailsData.accessstartdate
        ? dayjs(PersonalDetailsData.accessstartdate)
        : dayjs()
    }
    maxDate={
      PersonalDetailsData.accessstartdate
        ? dayjs(PersonalDetailsData.accessstartdate).add(1, 'month')
        : null
    }
    onChange={(newValue) => handlePersonalDetails(newValue, "accessenddate")}
    disabled={!PersonalDetailsData.accessstartdate} // Add this line to disable until onboard date is selected
    sx={{
      ...DatePickerStyle,
      backgroundColor: Boolean(errtext.PersonalDetailsData.accessenddate)
        ? "#FEE4E2"
        : "",
      "& .MuiInputBase-root": {
        color: errtext.PersonalDetailsData.accessenddate
          ? "#912018"
          : "#111927",
      },
      // Optional: Add opacity styling for disabled state
      "& .Mui-disabled": {
        opacity: 0.7,
        cursor: "not-allowed",
      },
    }}
    slotProps={{
      textField: {
        // Optional: Add helper text when disabled
        helperText: !PersonalDetailsData.accessstartdate ? "Please select onboard date first" : "",
      },
    }}
  />
  <ErrorTypography>
    {errtext.PersonalDetailsData.accessenddate}
  </ErrorTypography>
</Grid>



              {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Device Placement</StyledTypography>
              <Select
                name="device_placement"
                value={PersonalDetailsData.device_placement}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.device_placement
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.device_placement
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                <MenuItem value={`in`}>{`In`}</MenuItem>
                <MenuItem value={`out`}>{`Out`}</MenuItem>
                {/* {listBuilding.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.building_name}</MenuItem>;
                })}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.device_placement}
              </ErrorTypography>
            </Grid> */}

            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Device Type</StyledTypography>
              <Select
                name="type"
                value={PersonalDetailsData.type}
                onChange={(e) => handlePersonalDetails(e)}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.type
                      ? "#912018"
                      : "#111927",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                  },
                  backgroundColor: errtext.PersonalDetailsData.type
                    ? "#FEE4E2"
                    : " #F9FAFB",
                  width: "100%",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {deviceList.map((itm) => {
                  return <MenuItem value={itm.id}>{itm.title}</MenuItem>;
                })}
              </Select>
              <ErrorTypography>
                {errtext.PersonalDetailsData.type}
              </ErrorTypography>
            </Grid> */}

            {/* <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Port</StyledTypography>
              <TextField
                name="port"
                value={PersonalDetailsData.port}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.port}
              </ErrorTypography>
            </Grid> */}

          
            
           
          </Grid>

            <Box bgcolor="#FFFFFF" sx={{ border: "1px solid #E5E7EB", borderRadius: '8px 8px 8px 8px', mt : 2 }}>
                <Stack direction="column" justifyContent='end' alignItems='end' sx={{ py : 2, px : 2, display: 'flex', gap : 2 , flexDirection : { xs : 'column', sm : 'row'} }}>
                    <Button type='button' onClick={() => navigate(-1)} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#f3eae7ff" }}>Back</Button>
                    <Button type='button' disabled={loading} onClick={() => saveDevice()} sx={{ fontWeight: '600', width: "100px", color: 'white', backgroundColor: "#800000", ":hover" : {backgroundColor : '#800000'} }}>{id ? "Update" : "Create"}</Button>
                </Stack>
            </Box>
        </Box>
        </>
  )
}

export default AddOrganization